// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3mtKI","links":"styles_links__2yKB5"};